import { render, staticRenderFns } from "./feature_library_item.vue?vue&type=template&id=2c2b0060"
import script from "./feature_library_item.vue?vue&type=script&lang=js"
export * from "./feature_library_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports